export default class MedicalStaff {
  constructor (id, name, photo, gender, profession, professionalCertificate, location, landNumber, mobileNumber, email) {
    this._id = id
    this._name = name
    this._photo = photo
    this._gender = gender
    this._profession = profession
    this._professionalCertificate = professionalCertificate
    this._location = location
    this._landNumber = landNumber
    this._mobileNumber = mobileNumber
    this._email = email
  }

  get id () {
    return this._id
  }

  get name () {
    return this._name
  }

  get photo () {
    return this._photo
  }

  get profession () {
    return this._profession
  }

  get gender () {
    return this._gender
  }

  get professionalCertificate () {
    return this._professionalCertificate
  }

  get location () {
    return this._location
  }

  get landNumber () {
    return this._landNumber
  }

  get mobileNumber () {
    return this._mobileNumber
  }

  get email () {
    return this._email
  }
}
